export const COOKIE_AUTOTESTS_MARK = "magnit_autotests";
